import { Injector } from "@angular/core";
import { AuthService } from "../../../../service/auth-service/auth-service.service";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodePharmaceuticalForm } from "../Entity/TreeNodePharmaceuticalForm";
import { ErrorType } from "../../ErrorType";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeAuthorisedPharmaceuticalFormList extends Art57NodeList {
    constructor(injector: Injector, parent: Art57Node) {
      super(
        injector,
        new ListView(),
        'Authorised Pharmaceutical Forms ({param})'
      );
      this.labelNodeName = 'Authorised Pharmaceutical Forms';
      this.parent = parent;
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
    }
  
    override createChildTemplate(): Art57Node[] | null {
      let node = new TreeNodePharmaceuticalForm(this.ioc!, this);
      this.children?.push(node);
  
      this.refreshLabel();
      return [node];
    }
  
    override getMessage(): any {
      let pharmaceuticalforms: Art57Node[] = [];
      this.children?.forEach((node) => {
        let pharmaceuticalform = node as Art57Node;
        pharmaceuticalforms.push(pharmaceuticalform.getMessage());
      });
      if (pharmaceuticalforms.length > 0) {
        return { authpharmforms: { authpharmform: pharmaceuticalforms } };
      } else {
        return undefined;
      }
    }
  
    override getHeaders(): string[] {
      return ['EV Code', 'Pharmaceutical Form'];
    }
  
    override validateBusinessRules(): any[] {
      let errors: any = [];
      if ((!this.ioc!.get(AuthService).isEMAOrganisation()) &&
          (!this.children || this.children.length == 0)) {
        errors.push({
          node: this,
          errorID: this.key,
          errorType: ErrorType.bussinessValidationError,
          controlId: undefined,
          controlLabel: '',
          error: 'Section is Mandatory',
        });
      } else {
        errors.push({
          node: this,
          errorID: this.key,
          errorType: ErrorType.errorInactive,
          controlId: undefined,
          controlLabel: '',
          error: '',
        });
      }
  
      return errors;
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodeAuthorisedPharmaceuticalFormList =
        new TreeNodeAuthorisedPharmaceuticalFormList(this.ioc!, newParent);
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      return clonedNode;
    }
  }

